/**
 * Offers and partners (card У6; boards OfferList, OfferCard, OfferEditor,
 * OfferEditorErrors, OfferEmpty, PartnerList, PartnerCard, PartnerEditor).
 * English is the key set; Russian is `ru.offers.ts`.
 */
export const enOffers = {
  "u6.age.sec": "{n} s",
  "u6.age.min": "{n} min",
  "u6.age.hours": "{n} h",
  "u6.age.days": "{n} d",
  "u6.archive.title": "Archive «{name}»?",
  "u6.archive.body": "The offer leaves the list and the campaign pickers. Its numbers and conversions stay in the reports.",
  "u6.archive.partnerTitle": "Archive the partner «{name}»?",
  "u6.archive.partnerBody": "Its postbacks are no longer accepted. Its offers and numbers stay in the reports.",
  "u6.archive.done": "Archived",
  "u6.archive.failed": "Could not archive",
  "u6.cap.reached": "cap used up",
  "u6.cap.none": "no cap",
  "u6.card.loading": "Loading…",
  "u6.card.loadFailed": "Could not open the offer",
  "u6.card.edit": "Edit",
  "u6.card.duplicate": "Duplicate",
  "u6.card.capBadge": "Cap {used} / {limit} today",
  "u6.card.sourced": "managed by {source}",
  "u6.card.tabs": "Sections",
  "u6.card.tab.summary": "Summary",
  "u6.card.tab.campaigns": "Campaigns",
  "u6.card.tab.conversions": "Conversions",
  "u6.card.tab.history": "History",
  "u6.card.meta.partner": "Partner {name}",
  "u6.card.meta.countries": "countries {list}",
  "u6.card.where": "Where it leads",
  "u6.card.noLink": "No link — the offer only counts: no traffic is sent to it",
  "u6.card.how": "Transition",
  "u6.card.how.redirect": "Redirect (partner link)",
  "u6.card.macros": "Macros",
  "u6.card.payout": "Payout",
  "u6.card.rulesCount": "country rules: {n}",
  "u6.card.rules.country": "Country",
  "u6.card.rules.model": "Model",
  "u6.card.rules.amount": "Payout",
  "u6.card.caps": "Cap and limits",
  "u6.card.caps.today": "Today in {tz}",
  "u6.card.caps.none": "No daily cap",
  "u6.card.caps.total": "Total",
  "u6.card.caps.clicks": "Clicks a day",
  "u6.card.caps.onCap": "At the cap",
  "u6.card.caps.onCap.value": "a warning — traffic does not stop",
  "u6.card.statuses": "Partner statuses",
  "u6.card.statuses.fromPartner": "from the partner's settings",
  "u6.card.statuses.none": "The partner has sent no statuses yet",
  "u6.card.usage": "Where it is used",
  "u6.card.usage.none": "No campaign sent people to this offer in the period",
  "u6.card.usage.campaign": "Campaign",
  "u6.card.trend": "Leads and approvals by day",
  "u6.card.trend.none": "No leads in the period",
  "u6.card.lastConversions": "Latest conversions",
  "u6.card.conv.none": "No conversions in the period",
  "u6.card.conv.at": "Time",
  "u6.card.conv.status": "Status",
  "u6.card.conv.payout": "Payout",
  "u6.card.history.none": "No changes yet",
  "u6.col.offer": "Offer",
  "u6.col.partner": "Partner",
  "u6.col.payout": "Payout",
  "u6.col.countries": "Countries",
  "u6.col.cap": "Cap today",
  "u6.col.leads": "Leads",
  "u6.col.approve": "Approval",
  "u6.col.revenue": "Revenue",
  "u6.col.revenueUsd": "Revenue, $",
  "u6.col.campaigns": "Campaigns",
  "u6.col.status": "Status",
  "u6.col.model": "Model",
  "u6.col.currency": "Currency",
  "u6.col.postback": "Postback",
  "u6.col.statuses": "Statuses",
  "u6.col.offers": "Offers",
  "u6.common.all": "all",
  "u6.common.archive": "Archive",
  "u6.common.cancel": "Cancel",
  "u6.common.loading": "Loading…",
  "u6.common.more": "More",
  "u6.common.nothing": "Nothing found",
  "u6.common.pick": "Choose…",
  "u6.common.today": "Today",
  "u6.common.yesterday": "Yesterday",
  "u6.cur.usd": "US dollar",
  "u6.cur.eur": "euro",
  "u6.cur.rub": "Russian rouble",
  "u6.ed.title": "Offer {name}",
  "u6.ed.titleNew": "New offer",
  "u6.ed.sub": "A new payout applies to new conversions: past ones are not recomputed.",
  "u6.ed.subNew": "The draft keeps itself. The offer appears in campaigns after «Save».",
  "u6.ed.draft": "draft",
  "u6.ed.keys": "⌘S — save · Esc — close",
  "u6.ed.save": "Save",
  "u6.ed.saving": "Saving…",
  "u6.ed.saved": "Offer saved",
  "u6.ed.created": "Offer created",
  "u6.ed.saveFailed": "Could not save",
  "u6.ed.copySuffix": "(copy)",
  "u6.ed.sourced.title": "This offer is published by {source}",
  "u6.ed.sourced.body": "Name, partner, payout, countries, status and parameters are changed there — here they are read-only. The link, limits and statuses can be changed.",
  "u6.ed.err.title": "Not saved: {count} {word}",
  "u6.ed.err.word": "problem|problems",
  "u6.ed.err.url": "the link's address",
  "u6.ed.err.below": "The fields are marked below.",
  "u6.ed.err.rules": "a country repeated in the rules",
  "u6.ed.err.params": "parameters",
  "u6.ed.err.statuses": "statuses",
  "u6.ed.sectionOk": "no problems",
  "u6.ed.sectionErr": "error",
  "u6.ed.expand": "Expand",
  "u6.ed.sec.main": "Basics",
  "u6.ed.sec.link": "Partner link",
  "u6.ed.sec.payout": "Payout",
  "u6.ed.sec.caps": "Limits",
  "u6.ed.sec.params": "Parameters for the partner",
  "u6.ed.sec.conversions": "Conversions",
  "u6.ed.name": "Name",
  "u6.ed.name.hint": "shown in campaigns and reports",
  "u6.ed.network": "Partner",
  "u6.ed.network.pick": "Choose a partner",
  "u6.ed.network.search": "Partner name",
  "u6.ed.status": "Status",
  "u6.ed.countries": "Countries",
  "u6.ed.countries.add": "Add a country…",
  "u6.ed.url": "Address",
  "u6.ed.url.macros": "Insert a macro:",
  "u6.ed.how": "How to send",
  "u6.ed.how.redirect": "Redirect",
  "u6.ed.how.link": "Direct link",
  "u6.ed.model": "Model",
  "u6.ed.amount": "Payout",
  "u6.ed.rules": "Own payout for a country",
  "u6.ed.rules.rest": "other countries — the default",
  "u6.ed.rules.country": "Country…",
  "u6.ed.rules.add": "Country",
  "u6.ed.rules.remove": "Remove the row",
  "u6.ed.dailyCap": "Leads a day",
  "u6.ed.totalCap": "Leads in total",
  "u6.ed.noLimit": "no limit",
  "u6.ed.tz": "Count the day in",
  "u6.ed.onCap": "When the cap is used up",
  "u6.ed.onCap.value": "the tracker shows a warning; traffic does not stop and is not sent anywhere else",
  "u6.ed.tz.hint": "the workspace's time zone by default",
  "u6.ed.params.hint": "Added to the link as ?key=value",
  "u6.ed.params.key": "key",
  "u6.ed.params.value": "value",
  "u6.ed.params.add": "Parameter",
  "u6.ed.params.remove": "Remove the parameter",
  "u6.ed.goal": "Goal",
  "u6.ed.goal.default": "As in the workspace",
  "u6.ed.statuses.inherit": "Statuses come from the partner {network}'s settings: {words}.",
  "u6.ed.statuses.global": "the tracker's common dictionary",
  "u6.ed.statuses.atPartner": "Change at the partner",
  "u6.ed.statuses.own": "A status meaning for this offer only (optional)",
  "u6.ed.statuses.word": "the partner's status",
  "u6.ed.statuses.ours": "ours",
  "u6.ed.statuses.add": "Status",
  "u6.ed.statuses.remove": "Remove the status",
  "u6.ed.sum.caps": "{n} leads a day",
  "u6.ed.sum.inherit": "the partner's statuses",
  "u6.ed.sum.statuses": "own statuses: {n}",
  "u6.empty.title": "No offers yet",
  "u6.empty.body": "An offer is what you advertise: the partner's link, the payout and the countries it runs in. A campaign sends people to it from landers, and the tracker counts what it brought.",
  "u6.empty.step1": "Add a partner",
  "u6.empty.step1.done": "Partner added",
  "u6.empty.step1.sub": "its postback address goes into its cabinet",
  "u6.empty.step2": "Add an offer",
  "u6.empty.step2.sub": "the partner's link, the payout, the countries",
  "u6.empty.step3": "Build a campaign",
  "u6.empty.step3.sub": "source, landers, domain — and the link is ready",
  "u6.empty.add": "Add an offer",
  "u6.err.nameRequired": "A name is required",
  "u6.err.networkRequired": "Choose a partner",
  "u6.f.add": "Filter",
  "u6.f.apply": "Apply",
  "u6.f.reset": "Reset",
  "u6.f.back": "Back",
  "u6.f.clear": "Clear all",
  "u6.f.facets": "Filters",
  "u6.f.country": "Country",
  "u6.f.model": "Model",
  "u6.kpi.clicks": "Clicks",
  "u6.kpi.leads": "Leads",
  "u6.kpi.approved": "Approvals",
  "u6.kpi.approveShare": "{pct} of decided",
  "u6.kpi.hold": "On hold",
  "u6.kpi.inTransit": "≈ {sum} on the way",
  "u6.kpi.revenue": "Revenue",
  "u6.kpi.cost": "Cost",
  "u6.kpi.profit": "Profit",
  "u6.kpi.roi": "ROI",
  "u6.link.check": "Check the link",
  "u6.link.again": "Check again",
  "u6.link.checking": "Checking…",
  "u6.link.never": "The link has not been checked",
  "u6.link.result": "Checked {at} — {status} at {host}{hops}, {ms} ms",
  "u6.link.clickOk": "the click macro is there",
  "u6.link.clickMissing": "no click macro — the postback will have nothing to attach to",
  "u6.link.err.dns": "No such address: the domain does not resolve",
  "u6.link.err.timeout": "No answer in 8 seconds",
  "u6.link.err.tls": "The site's certificate does not verify",
  "u6.link.err.refused": "The server refuses the connection",
  "u6.link.err.blocked": "The address points into a private network — not opened",
  "u6.link.err.badUrl": "Not an address: it needs https:// and no spaces",
  "u6.link.err.http": "Did not open — connection error",
  "u6.word.redirects": "redirect|redirects|redirects",
  "u6.model.cpa": "per confirmed order",
  "u6.model.cpl": "per lead",
  "u6.model.cps": "per sale",
  "u6.model.revshare": "revenue share",
  "u6.model.cpc": "per click",
  "u6.model.cpm": "per thousand impressions",
  "u6.model.cpi": "per install",
  "u6.model.doi": "per confirmed sign-up",
  "u6.model.soi": "per sign-up",
  "u6.offer.id": "offer id",
  "u6.offers.title": "Offers",
  "u6.offers.subtitle": "What you advertise: the partner's link, the payout and the countries. Numbers are for the period at the top.",
  "u6.offers.new": "New offer",
  "u6.offers.search": "Offer name or id",
  "u6.offers.loadFailed": "Could not load the offers",
  "u6.offers.noneMatch": "No offers match",
  "u6.our.unknown": "—",
  "u6.our.approved": "Approved",
  "u6.our.hold": "Hold",
  "u6.our.rejected": "Rejected",
  "u6.our.refunded": "Refunded",
  "u6.our.trash": "Trash",
  "u6.partners.title": "Partners",
  "u6.partners.subtitle": "Who pays for conversions. Here: the postback address for the partner and how to read its statuses.",
  "u6.partners.new": "New partner",
  "u6.partners.search": "Partner name",
  "u6.partners.loadFailed": "Could not load the partners",
  "u6.partners.none": "No partners match",
  "u6.partners.unmapped": "unknown statuses arrived ({n}). Leads on hold until you say what they are: {leads}.",
  "u6.partners.map": "Map",
  "u6.partners.totals": "Total, partners: {n}",
  "u6.partners.words": "{known} of {total}",
  "u6.partners.newWords": "new: {n}",
  "u6.pb.arrivesShort": "arriving",
  "u6.pb.silentShort": "none for {age}",
  "u6.pb.ago": "{age} ago",
  "u6.pb.arrives": "arriving · {age} ago",
  "u6.pb.silent": "none for {age}",
  "u6.pb.silentNever": "not a single postback",
  "u6.pb.none": "not set up",
  "u6.pbf.all": "All",
  "u6.pbf.arrives": "Arriving",
  "u6.pbf.silent": "Silent",
  "u6.pbf.none": "Not set up",
  "u6.pc.loadFailed": "Could not open the partner",
  "u6.pc.meta": "{model} by default · payouts in {currency}, reports in USD at the lead day's rate · offers: {offers}",
  "u6.pc.openCabinet": "open at the partner",
  "u6.pc.tab.postback": "Postback and statuses",
  "u6.pc.tab.offers": "Offers",
  "u6.pc.tab.postbacks": "Postbacks",
  "u6.pc.address": "Postback address — paste it into {name}'s cabinet",
  "u6.pc.copy": "Copy",
  "u6.pc.copied": "Address copied",
  "u6.pc.onCampaignDomain": "The address works on the domain of any campaign with this partner's offers.",
  "u6.pc.ourClick": "our click",
  "u6.pc.payoutLine": "{payout} in {currency} → USD at the day's rate",
  "u6.pc.testHint": "A test postback is sent from a campaign («Links and postbacks») — on your own test click.",
  "u6.pc.st.title": "How to read {name}'s statuses",
  "u6.pc.st.warn": "An unknown status counts as hold until you map it. Such leads now: {leads}.",
  "u6.pc.st.none": "No statuses arrived in 30 days",
  "u6.pc.st.theirs": "Status at {name}",
  "u6.pc.st.ours": "Ours",
  "u6.pc.st.leads": "Leads",
  "u6.pc.st.new": "new",
  "u6.pc.st.dict": "by the dictionary",
  "u6.pc.st.saved": "Saved. Leads on the newly mapped statuses are reapplied within a minute.",
  "u6.pc.offers": "{name}'s offers",
  "u6.pc.allOffers": "all {n}",
  "u6.pc.noOffers": "The partner has no offers",
  "u6.pc.lastPostbacks": "Latest postbacks",
  "u6.pc.toJournal": "to the journal",
  "u6.pc.noPostbacks": "No postbacks in the period",
  "u6.pc.pb.at": "When",
  "u6.pc.pb.click": "Click",
  "u6.pc.pb.status": "Status",
  "u6.pc.pb.result": "Result",
  "u6.pe.title": "Partner {name}",
  "u6.pe.titleNew": "New partner",
  "u6.pe.sub": "The postback address does not change on save.",
  "u6.pe.saved": "Partner saved",
  "u6.pe.created": "Partner created",
  "u6.pe.sec.main": "Basics",
  "u6.pe.sec.security": "Protection",
  "u6.pe.sec.silence": "When postbacks stop",
  "u6.pe.currency": "Payout currency",
  "u6.pe.model": "Default model",
  "u6.pe.cabinet": "Cabinet site",
  "u6.pe.cabinet.hint": "for the «open at the partner» link",
  "u6.pe.click": "Click",
  "u6.pe.status": "Status",
  "u6.pe.payout": "Payout",
  "u6.pe.key": "Postback key",
  "u6.pe.key.hint": "set at creation: a new key would cut off the address in the partner's cabinet",
  "u6.pe.ips": "Accept only from IPs",
  "u6.pe.ips.hint": "optional; an address or a subnet",
  "u6.pe.ips.any": "any",
  "u6.pe.silence": "Tell me if silent longer than",
  "u6.pe.silence.hint": "the message goes to «Data health»",
  "u6.pe.silence.never": "Never",
  "u6.pe.silence.hours": "{n} h",
  "u6.pe.silence.days": "{n} days",
  "u6.status.active": "Running",
  "u6.status.paused": "Paused",
  "u6.status.capped": "Capped today",
  "u6.status.archived": "Archived",
  "u6.totals.page": "Page total",
  "u6.view.label": "View",
  "u6.view.active": "Running",
  "u6.view.capped": "Capped today",
  "u6.view.silent": "No leads for 7 days",
  "u6.view.mine": "Mine",
  "u6.view.archived": "Archive",
  "u6.health.silent": "Partners silent longer than you asked: {count}",
  "u6.health.silent.sub": "No postbacks — leads may be waiting at the partner. Check the address in its cabinet.",
  "u6.health.open": "Partners",
} as const;
